import { V3Footer } from "../V3Footer";
import {
    ContentGridWithFooterWrapper,
    ContentGridDynamicElement,
    ContentGridMainElement,
    ContentGridFooterElement,
    ContentGridFooterPadding
} from "./ContentGridWithFooter.styles";

import type { JSX } from "react";

interface ContentGridWithFooterProps {
    skipSideBarDesktop?: boolean;
    useExtendedBreakpoint?: boolean;
    isPrivateView: boolean;
    dynamicContent: JSX.Element;
    mainContent: JSX.Element;
    disableInteraction?: boolean;
    showAuthoryBranding?: boolean;
}

export const ContentGridWithFooter = ({
    skipSideBarDesktop = false,
    useExtendedBreakpoint = false,
    disableInteraction = false,
    isPrivateView,
    dynamicContent,
    mainContent,
    showAuthoryBranding = true
}: ContentGridWithFooterProps) => (
    <ContentGridWithFooterWrapper $skipSideBarDesktop={skipSideBarDesktop} $isPrivateView={isPrivateView} $disableInteraction={disableInteraction}>
        <ContentGridDynamicElement>{dynamicContent}</ContentGridDynamicElement>
        <ContentGridMainElement>{mainContent}</ContentGridMainElement>
        <ContentGridFooterElement>
            <ContentGridFooterPadding>
                <V3Footer isPrivateView={isPrivateView} useExtendedBreakpoint={useExtendedBreakpoint} showAuthoryBranding={showAuthoryBranding} />
            </ContentGridFooterPadding>
        </ContentGridFooterElement>
    </ContentGridWithFooterWrapper>
);
